'use strict';

wbApp.controller('OnlineCourseCtrl', ['$scope', '$translate',
function ($scope, $translate) {

    $scope.model = {
        isTeacher: isTeacher,
        joinMeetingUrl: courseSchedule.JoinMeetingUrl,
        startMeetingUrl: courseSchedule.StartMeetingUrl,
        courseFullName: courseSchedule.Subject,
        subjectName: courseSchedule.SubjectName,
        startDate: courseSchedule.StartDate,
        endDate: courseSchedule.EndDate,
        notes: courseSchedule.Notes,
        subjectDescription: course.SubjectDescription,
        courseDescription: course.CourseDescription,
        teacherFullName: course.TeacherFullName,
        teacherWorkExperience: course.TeacherWorkExperience,
        teacherWorkWithChildren: course.TeacherWorkWithChildren,
        teacherPhotoUrl: course.TeacherPhotoUrl
    }

    if ((!attendance || !attendance.length) && !$scope.model.isTeacher) {
        $scope.serverError = { errors: [{ message: $translate.instant('TXT_ERROR_NO_STUDENTS_REGISTERED_ON_THIS_LESSON') }] };        
    }
}]);
